import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0 w-full',
    wrapper: 'relative overflow-hidden',
    label:
      'text-system-gray-700 peer-disabled:text-text-inactive absolute top-[10px] left-[12px] -z-10 origin-[0] -translate-y-3.5 scale-75 transform text-base font-light whitespace-nowrap transition-all duration-200 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-3.5 peer-focus:scale-75',
    input:
      'peer focus:placeholder:text-system-gray-700 disabled:placeholder:text-text-inactive disabled:text-text-inactive border-bg-items-black block w-full appearance-none border-0 border-b-1 px-[12px] py-[27px] pb-1 text-base font-light transition-all duration-200 placeholder:text-transparent placeholder:opacity-0 placeholder:transition-all placeholder:duration-200 focus:outline-none focus:placeholder:opacity-100 [&:-webkit-autofill]:[box-shadow:0_0_0_1000px_transparent_inset] [&:-webkit-autofill]:[transition:background-color_5000s_ease-in-out_0s] [&:-webkit-autofill:focus]:[box-shadow:0_0_0_1000px_transparent_inset] [&:-webkit-autofill:hover]:[box-shadow:0_0_0_1000px_transparent_inset]',
    helperText: 'text-text-inactive px-4 pt-1 text-sm font-light',
    iconContainer: 'text-icon-secondary absolute right-4 bottom-3.5 h-6 w-6',
    required: 'text-text-error ml-0.5'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-text-error',
        input: 'text-text-error',
        label: 'text-text-error'
      }
    },
    success: {
      true: {
        helperText: 'text-text-success'
      }
    },
    white: {
      true: {
        label: 'text-white',
        input: 'border-white text-white',
        helperText: 'text-white'
      }
    },
    icon: {
      true: {
        input: 'pr-12'
      }
    },
    withLabel: {
      true: {
        input: ''
      },
      false: {
        input:
          'placeholder:text-secondary-hover pt-4 pb-3 placeholder:opacity-100'
      }
    },
    mode: {
      base: '',
      profile: {
        label: 'top-5 -translate-y-3 peer-focus:-translate-y-3 lg:top-4',
        input: 'max-lg:pb-1.5'
      }
    }
  }
});
